import { createContext, RefObject, useContext } from "react";

const AppScrollContext = createContext<RefObject<HTMLDivElement | null> | null>(null);

export const AppScrollProvider = AppScrollContext.Provider;

export function useAppScrollContainer() {
  return useContext(AppScrollContext);
}
